import React from 'react';
import { TeamLogoConfig } from '../../types';

export const BACKGROUND_SHAPES: { [key: string]: string } = {
  classic: 'M 100,20 C 140,20 170,25 170,50 C 170,110 130,150 100,180 C 70,150 30,110 30,50 C 30,25 60,20 100,20 Z',
  fantasy: 'M 100,35 C 115,22 135,22 155,30 C 160,32 165,40 160,50 C 150,70 165,100 175,115 C 180,122 175,130 165,130 C 155,130 148,120 145,115 C 140,135 125,165 100,180 C 75,165 60,135 55,115 C 52,120 45,130 35,130 C 25,130 20,122 25,115 C 35,100 50,70 40,50 C 35,40 40,32 45,30 C 65,22 85,22 100,35 Z',
  cyber: 'M 100,20 L 170,40 L 160,110 L 100,180 L 40,110 L 30,40 Z',
  gothic: 'M 100,25 C 120,25 155,15 170,35 C 175,60 160,115 100,175 C 40,115 25,60 30,35 C 45,15 80,25 100,25 Z',
  circle: 'M 100,20 C 144,20 180,56 180,100 C 180,144 144,180 100,180 C 56,180 20,144 20,100 C 20,56 56,20 100,20 Z',
  diamond: 'M 100,20 L 180,100 L 100,180 L 20,100 Z',
  heart: 'M 100,45 C 100,45 130,15 165,30 C 185,55 170,110 100,175 C 30,110 15,55 35,30 C 70,15 100,45 100,45 Z',
  crestRoyal: 'M 30,20 L 170,20 L 170,100 C 170,145 138,180 100,180 C 62,180 30,145 30,100 Z',
  spiked: 'M 100,15 L 135,35 L 170,30 L 165,100 C 165,145 135,175 100,185 C 65,175 35,145 35,100 L 30,30 L 65,35 Z',
  wave: 'M 100,25 C 125,15 150,30 170,25 C 175,70 165,130 100,180 C 35,130 25,70 30,25 C 50,30 75,15 100,25 Z',
  octagon: 'M 100,20 L 155,42 L 180,100 L 155,158 L 100,180 L 45,158 L 20,100 L 45,42 Z',
  horned: 'M 100,40 C 120,20 160,20 170,35 C 170,60 160,110 130,145 L 100,180 L 70,145 C 40,110 30,60 30,35 C 40,20 80,20 100,40 Z',
  baroque: 'M 100,25 C 130,20 160,35 160,55 C 160,80 170,110 145,145 L 100,180 L 55,145 C 30,110 40,80 40,55 C 40,35 70,20 100,25 Z',
  crestSharp: 'M 100,20 L 155,30 L 175,85 L 155,120 L 100,180 L 45,120 L 25,85 L 45,30 Z',
  trapezoid: 'M 50,40 L 150,40 L 180,160 L 20,160 Z',
};

export const FOREGROUND_SHAPES: { [key: string]: string } = {
  claw: 'M 65,55 C 70,75 62,115 52,130 C 58,110 68,80 72,55 Z M 98,40 C 104,70 92,125 82,145 C 90,120 102,80 106,40 Z M 131,55 C 137,75 129,115 119,130 C 125,110 135,80 139,55 Z',
  rune: 'M 100,35 C 95,50 80,65 80,85 C 80,115 120,115 120,85 C 120,75 110,65 105,50 C 115,65 130,80 130,95 C 130,125 70,125 70,95 C 70,65 90,45 100,35 Z',
  water: 'M 100,35 C 115,55 135,75 135,100 C 135,122 117,140 95,140 C 73,140 60,122 65,100 C 68,85 80,65 100,35 Z M 95,65 C 85,80 82,95 86,110 C 90,120 102,125 110,115 C 118,105 112,90 105,80 C 100,75 97,70 95,65 Z',
  star: 'M 100,35 L 118,72 L 158,78 L 129,106 L 136,146 L 100,127 L 64,146 L 71,106 L 42,78 L 82,72 Z',
  lightning: 'M 115,35 L 65,95 L 95,95 L 85,155 L 135,85 L 105,85 Z',
  crown: 'M 55,130 L 145,130 L 155,80 L 125,105 L 100,65 L 75,105 L 45,80 Z',
  sword: 'M 96,30 L 104,30 L 104,130 L 115,130 L 115,138 L 104,138 L 104,165 C 104,167 96,167 96,165 L 96,138 L 85,138 L 85,130 L 96,130 Z',
  shieldMini: 'M 100,50 C 125,50 140,53 140,70 C 140,110 120,135 100,150 C 80,135 60,110 60,70 C 60,53 75,50 100,50 Z',
  skull: 'M 100,50 C 125,50 135,70 135,90 C 135,115 125,120 120,120 L 120,140 C 120,145 115,145 110,145 L 110,135 L 90,135 L 90,145 C 85,145 80,145 80,140 L 80,120 C 75,120 65,115 65,90 C 65,70 75,50 100,50 Z M 85,90 C 85,95 90,95 90,90 C 90,85 85,85 85,90 Z M 115,90 C 115,95 110,95 110,90 C 110,85 115,85 115,90 Z',
  wings: 'M 100,90 C 115,70 145,55 170,60 C 160,85 135,115 100,135 C 65,115 40,85 30,60 C 55,55 85,70 100,90 Z',
  phoenix: 'M 100,50 C 105,65 115,75 135,80 C 120,85 115,95 115,110 C 115,120 125,130 100,150 C 75,130 85,120 85,110 C 85,95 80,85 65,80 C 85,75 95,65 100,50 Z',
  fist: 'M 85,100 L 85,140 L 115,140 L 115,100 C 115,90 125,90 125,105 L 125,140 L 135,140 L 135,95 C 135,80 120,70 105,80 C 100,75 95,75 90,80 C 80,70 65,80 65,95 L 65,140 L 75,140 L 75,105 C 75,90 85,90 85,100 Z',
  wolf: 'M 100,45 C 105,45 110,55 108,65 C 115,70 125,65 135,75 C 125,80 120,90 122,100 C 118,95 112,95 108,102 C 108,115 115,130 120,140 C 110,138 100,130 95,115 C 92,125 85,135 75,140 C 82,125 88,110 88,100 C 82,102 78,98 75,92 C 85,85 85,75 80,70 C 90,65 95,55 100,45 Z',
  anchor: 'M 100,45 C 105,45 110,50 110,55 C 110,60 105,65 100,65 C 95,65 90,60 90,55 C 90,50 95,45 100,45 Z M 96,68 L 104,68 L 104,130 C 120,128 135,118 140,105 L 145,107 C 138,125 120,138 100,140 C 80,138 62,125 55,107 L 60,105 C 65,118 80,128 96,130 Z M 85,80 L 115,80 L 115,88 L 85,88 Z',
  compass: 'M 100,40 L 106,85 L 150,85 L 112,100 L 130,140 L 100,112 L 70,140 L 88,100 L 50,85 L 94,85 Z',
  leaf: 'M 100,45 C 115,55 135,70 125,105 C 120,120 110,130 100,150 C 90,130 80,120 75,105 C 65,70 85,55 100,45 Z M 98,75 L 102,75 L 102,130 L 98,130 Z',
};

interface TeamLogoProps {
  logo?: TeamLogoConfig;
  size?: number;
  style?: React.CSSProperties;
}

const TeamLogo: React.FC<TeamLogoProps> = ({ logo, size = 48, style }) => {
  const bgPath = logo && BACKGROUND_SHAPES[logo.backgroundShape] 
    ? BACKGROUND_SHAPES[logo.backgroundShape] 
    : BACKGROUND_SHAPES.classic;
    
  const bgColor = logo ? logo.backgroundColor : '#cccccc';
  
  const fgPath = logo && FOREGROUND_SHAPES[logo.foregroundShape]
    ? FOREGROUND_SHAPES[logo.foregroundShape]
    : null;
    
  const fgColor = logo ? logo.foregroundColor : '#666666';

  return (
    <svg 
      viewBox="0 0 200 200" 
      width={size} 
      height={size} 
      style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}
    >
      <path d={bgPath} fill={bgColor} />
      {fgPath && (
        <g transform="translate(100, 100) scale(0.6) translate(-100, -100)">
          <path d={fgPath} fill={fgColor} />
        </g>
      )}
    </svg>
  );
};

export default TeamLogo;
